import "vant/es/popup/style";
import _Popup from "vant/es/popup";
import "core-js/modules/web.url-search-params.delete.js";
import "core-js/modules/web.url-search-params.has.js";
import "core-js/modules/web.url-search-params.size.js";
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, isRef as _isRef, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
  class: "artwork-special-box"
};
const _hoisted_2 = {
  class: "artwork-special-content"
};
const _hoisted_3 = {
  class: "artwork-special-footer"
};
import { useAppStore } from "@/store/modules/app";
import { storeToRefs } from "pinia";
import { useI18n } from "vue-i18n";
import { getMultiLangValue, openInCurrentTab } from "@/utils/tool";
import { computed } from "vue";
import ButtonView from "./ButtonView.vue";
export default {
  __name: 'ArtworkSpecialDialog',
  setup(__props) {
    const appStore = useAppStore();
    const {
      showArtworkSpecialDialog,
      artworkSpecialList
    } = storeToRefs(appStore);
    const displayArtworks = computed(() => artworkSpecialList.value.length > 0 ? [artworkSpecialList.value[0]] : []);
    const toSpecialPage = _url => {
      const url = new URL(_url);
      url.searchParams.set("isFromScan", "1");
      openInCurrentTab(url.toString());
    };
    const {
      locale,
      t
    } = useI18n();
    return (_ctx, _cache) => {
      return _openBlock(), _createBlock(_unref(_Popup), {
        show: _unref(showArtworkSpecialDialog),
        "onUpdate:show": _cache[1] || (_cache[1] = $event => _isRef(showArtworkSpecialDialog) ? showArtworkSpecialDialog.value = $event : null),
        class: "artwork-special-popup",
        "close-on-click-overlay": false,
        "close-on-popstate": true
      }, {
        default: _withCtx(() => [_createElementVNode("section", _hoisted_1, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(displayArtworks.value, (item, index) => {
          return _openBlock(), _createElementBlock("div", {
            key: index,
            class: "artwork-special-item"
          }, [_createElementVNode("p", _hoisted_2, _toDisplayString(_unref(getMultiLangValue)(item.special_word, _unref(locale))), 1), _createElementVNode("div", _hoisted_3, [_createVNode(ButtonView, {
            type: "add",
            size: "small",
            onClick: _cache[0] || (_cache[0] = $event => _unref(appStore).closeArtworkSpecialDialog())
          }, {
            default: _withCtx(() => [_createTextVNode(_toDisplayString(_unref(t)("common.close")), 1)]),
            _: 1
          }), _createVNode(ButtonView, {
            type: "submit",
            size: "small",
            onClick: () => {
              _unref(appStore).closeArtworkSpecialDialog();
              toSpecialPage(item.special_redirect_url);
            }
          }, {
            default: _withCtx(() => [_createTextVNode(_toDisplayString(_unref(t)("common.join")), 1)]),
            _: 2
          }, 1032, ["onClick"])])]);
        }), 128))])]),
        _: 1
      }, 8, ["show"]);
    };
  }
};